import React from "react";
import { theme } from "../theme";
import { useCurrencyFormatter } from "../../../../Components/Hooks/useCurrencyFormatter";

// Contract amounts are always stored/entered in EUR; `ronAmount` is an
// optional backend-computed conversion shown as a smaller secondary figure
// for RON-denominated contracts.
const MoneyDisplay = ({ eurAmount, ronAmount, size = 23, color, block = true }) => {
  const { formatCurrency } = useCurrencyFormatter();

  return (
    <span style={{ display: block ? "block" : "inline-flex", alignItems: "baseline", gap: 6 }}>
      <span
        style={{
          display: block ? "block" : "inline",
          fontSize: size,
          fontWeight: 650,
          fontVariantNumeric: "tabular-nums",
          color: color || theme.text,
        }}
      >
        {formatCurrency(eurAmount, "EUR")}
      </span>
      {ronAmount != null && (
        <span
          style={{
            display: block ? "block" : "inline",
            marginTop: block ? 2 : 0,
            fontSize: Math.max(11, Math.round(size * 0.55)),
            fontWeight: 600,
            color: theme.textMuted,
            fontVariantNumeric: "tabular-nums",
          }}
        >
        {formatCurrency(ronAmount, "RON")}
        </span>
      )}
    </span>
  );
};

export default MoneyDisplay;
